"use strict";

var _jquery = _interopRequireDefault(require("jquery"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Adds a dropdown mega menu. It needs to be hooked up on the root <ul> element
 * with the following structure:
 *
 * <ul class="my-class"> // Root element
 *     <li> (level1)
 *         <a>Group 1</a>
 *         <ul>
 *              <li> (level2)
 *                  <a>Menu column header 1</a>
 *                  <ul>
 *                      <li>Dropdown menu item 1</li>
 *                      <li>Dropdown menu item 2</li>
 *                      ... (more items)
 *                  </ul>
 *              </li>
 *              ... (more columns)
 *         </ul>
 *     </li>
 *     ... (more groups)
 * </ul>
 *
 * The plugin will add the class 'dgs-mega-menu' to the Root element, used to provide some basic styling.
 *
 * You can provide a set of options to customize the plugin:
 *
 * @param string activeClass    <active>      Class that will be added to the active group
 * @param string emptyMenuClass <no-dropdown> Class that will be added when an item does not have elements for dropdown
 * @param bool   secondLevelNav <true>        Enables or disables the second level navigation
 * @param string disabledClass  <as-text>     Class that will be added if the secondLevelNav is set to true
 * @param bool   navTracking    <true>        Enables tracking of navigation, adding the "current" class to the elements
 *                                            which belong to the current page
 * @param bool   hover          <false>       By default the mega menu is open on click. Set this to true
 *                                            to enable opening on hover. DOES NOT WORK ON MOBILE!
 *
 * An example of how to invoke the mega-menu:
 *  $(".my-class").megaMenu({
 *      hover: true,
 *      activeClass: "activated",
 *      transitionBg: null
 *  });
 *
 */
(function ($) {
  $.fn.megaMenu = function (customOptions) {
    // This cannot be overwritten from the outside
    var privateSettings = {
      transitionBg: 'fade'
    };
    var settings = $.extend({}, $.fn.megaMenu.defaults, customOptions, privateSettings); // Extend the custom settings

    var $this = $(this);
    var megamenuClass = 'dgs-mega-menu'; // DO NOT CHANGE THIS: This is used by the foundation styling

    var f = {
      // Initialization of the plugin
      init: function init() {
        f.actions.addClasses();
        $this.children('li').each(function () {
          if (settings.hover) {
            f.events.openOnHover($(this));
          } else {
            f.events.openOnClick($(this));
          }
        }); // Disables the second level navigation, so it works more as a title than a page

        if (settings.secondLevelNav === false) {
          f.actions.disableSecondLevelNav();
        }
      },
      actions: {
        /**
                 * Add required class for the root <ul> and for the groups that do not have a sub-elements
                 */
        addClasses: function addClasses() {
          $this.addClass(megamenuClass); // Check that there is no third nested elements

          $this.children('li').each(function () {
            if ($(this).find('> ul > li').length === 0) {
              // HINT: Configure the nested level
              $(this).addClass(settings.emptyMenuClass);
            }
          });

          if (settings.navTracking === true) {
            $this.find(' > li a').each(function () {
              var href = $(this).attr('href');

              if (window.location.pathname.indexOf(href) === 0 || window.location.pathname === href) {
                $(this).addClass('current');
              }
            });
          } else if (typeof settings.navTracking === 'function') {
            settings.navTracking($this); // Support custom navigation
          }
        },

        /**
         * Opens a group of the given menu item, using the given animations and adding required classes
         *
         * @param $menuItem <li/> Group element
         */
        openMenuItem: function openMenuItem($menuItem) {
          if ($menuItem.hasClass(settings.emptyMenuClass)) {
            return;
          }

          $menuItem.children('a').addClass(settings.activeClass);
          $menuItem.addClass(settings.expandedClass);
          var toAnimate = $menuItem.children('ul').stop(true).css('display', settings.displayTypeBg).hide();

          if (settings.transitionBg === 'slide') {
            toAnimate.slideDown('fast');
          } else {
            toAnimate.fadeIn('fast');
          }
        },

        /**
                 * Close a group of the given menu item, using the given animations and removing required classes
                 *
                 * @param $menuItem <li/> Group element
                 */
        closeMenuItem: function closeMenuItem($menuItem) {
          $menuItem.children('a').removeClass(settings.activeClass);

          if (settings.transitionBg === 'slide') {
            $menuItem.children('ul').stop(true).hide();
          } else {
            setTimeout(function () {
              $menuItem.children('ul').stop(true).fadeOut('fast');
            }, settings.fadeOutTimeout);
          }
        },
        isMenuOpen: function isMenuOpen($menuItem) {
          return $menuItem.children('ul:visible').length > 0;
        },

        /**
                 * Disables the second level element from being clickable, so it is more like a title than a page.
                 */
        disableSecondLevelNav: function disableSecondLevelNav() {
          $this.find('> li > ul > li > a').each(function () {
            $(this).addClass(settings.disabledClass).click(function (event) {
              event.preventDefault();
            });
          });
        }
      },
      events: {
        /**
                 * Opens a dropdown menu for the given element when is hover.
                 *
                 * @param $menuItem <li/> Group element that has subitems
                 */
        openOnHover: function openOnHover($menuItem) {
          $menuItem.children('a').unbind('click');
          $menuItem.hover(function () {
            f.actions.openMenuItem($menuItem);
          }, function () {
            f.actions.closeMenuItem($menuItem);
          });
        },

        /**
                 * Handles the click event to open a menu item
                 *
                 * @param $menuItem <li/> Group element that has the sub-items
                 */
        openOnClick: function openOnClick($menuItem) {
          $menuItem.unbind('mouseenter mouseleave');
          var $item = $menuItem.children('a');
          $item.click(function (event) {
            var hasDropdown = !$(this).parent().hasClass(settings.emptyMenuClass);

            if (hasDropdown) {
              event.preventDefault();

              if (f.actions.isMenuOpen($menuItem)) {
                f.actions.closeMenuItem($menuItem);
              } else {
                // Close the open elements
                $this.find('> li.expanded').each(function () {
                  f.actions.closeMenuItem($(this));
                });
                f.actions.openMenuItem($menuItem);
              }
            }
          });
        }
      }
    }; // This is where everything begins

    return this.each(function () {
      f.init();
    });
  }; // Public defaults

  /*
  $.fn.megaMenu.defaults = {
    activeClass: 'active',
    emptyMenuClass: 'no-dropdown',
    expandedClass: 'expanded',
    secondLevelNav: true,
    disabledClass: 'as-text',
    navTracking: true,
    hover: false,
    displayTypeBg: 'block',
    fadeOutTimeout: 0,
  } */

})(_jquery["default"]);